import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ConflictDialogProps {
  /** Whether the conflict dialog is open. */
  open: boolean;
  /** Reloads the server document, discarding local edits and history. */
  onReload: () => void;
  /** Keeps the local document and re-saves it against the server version. */
  onKeep: () => void;
}

/**
 * Explicit 409-conflict recovery dialog for the document editor. The document
 * changed on the server since the editor last read it; recovery is reload or
 * keep, never a silent merge. "Reload server version" replaces the working
 * document with the server HTML and resets undo/redo; "Keep editing" keeps the
 * local HTML but adopts the new server version to save against.
 * @param open - Whether the dialog is open
 * @param onReload - Reloads the server document, discarding local edits
 * @param onKeep - Keeps the local document, re-saving against the server version
 */
export function ConflictDialog({
  open,
  onReload,
  onKeep,
}: ConflictDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Document changed on the server</AlertDialogTitle>
          <AlertDialogDescription>
            This document was updated elsewhere since you started editing.
            Reload the server version to discard your local changes and undo
            history, or keep editing to overwrite the server copy with your
            changes.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onReload}>
            Reload server version
          </AlertDialogCancel>
          <AlertDialogAction onClick={onKeep}>Keep editing</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
